import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ApiService from '../../services/ApiService';
import LoyaltyContext from './LoyaltyContext';
import FileNotFound from '../FileNotFound';

const Loyalty = React.forwardRef((props, ref) => {
  const { className, user, dispatch, ...rest } = props; // eslint-disable-line

  const { loyaltyClientId, loyaltyDealerCode, loyaltyCultureCode } = user.branch;

  const createCustomer = customer => {
    return ApiService.post('loyalty/customers', customer);
  };

  const fetchCustomer = customerId => {
    return ApiService.get(`loyalty/customers/${customerId}`);
  };

  const fetchCustomers = params => {
    return ApiService.get('loyalty/customers', { params });
  };

  const fetchLocalCustomers = params => {
    return ApiService.get('loyalty/local-customers', { params });
  };

  const fetchCustomerOffers = (customerId, params = {}) => {
    return ApiService.get(`loyalty/customers/${customerId}/offers`, { params });
  };

  const fetchOffer = offerId => {
    return ApiService.get(`loyalty/offers/${offerId}`);
  };

  const fetchPublicOffers = params => {
    return ApiService.get('loyalty/offers', { params });
  };

  const fetchRedemptions = (customerId, params = {}) => {
    return ApiService.get(`loyalty/customers/${customerId}/redemptions`, { params });
  };

  const fetchBestOffers = (customerId, params = {}) => {
    return ApiService.get(`loyalty/customers/${customerId}/offers/best`, { params });
  };

  const redeem = (customerId, redemption = {}) => {
    return ApiService.post(`loyalty/customers/${customerId}/redemptions`, redemption);
  };

  const validateRedemption = redemptionId => {
    return ApiService.post(`loyalty/redemptions/${redemptionId}/validate`);
  };

  const voidRedemption = redemptionId => {
    return ApiService.post(`loyalty/redemptions/${redemptionId}/void`);
  };

  const updateCustomer = (customerId, customer = {}) => {
    return ApiService.put(`loyalty/customers/${customerId}`, customer);
  };

  const getDealerNetwork = () => {
    return ApiService.get('loyalty/dealercodes');
  };

  const context = {
    createCustomer,
    fetchBestOffers,
    fetchCustomer,
    fetchCustomerOffers,
    fetchCustomers,
    fetchLocalCustomers,
    fetchOffer,
    fetchPublicOffers,
    fetchRedemptions,
    getDealerNetwork,
    loyaltyClientId,
    loyaltyCultureCode,
    loyaltyDealerCode,
    redeem,
    updateCustomer,
    validateRedemption,
    voidRedemption,
  };

  if (!loyaltyClientId) {
    return <FileNotFound>Loyalty client is not set up for this branch</FileNotFound>;
  }

  return (
    <LoyaltyContext.Provider value={context}>
      <div {...rest} ref={ref} className={classNames(className, 'loyalty-container')} />
    </LoyaltyContext.Provider>
  );
});

Loyalty.propTypes = {
  className: PropTypes.string,
  user: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    user: state.app.user,
  };
}

export default connect(mapStateToProps)(Loyalty);
